import * as Types from 'Types';

export const getMediaQuery = (state: Types.RootState) => state.mediaQuery;
